import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "persistent": "",
      "isOpen": _vm.value,
      "max-width": "1200px",
      "action-save-loading": _vm.isSaving,
      "action-save-label": _vm.widgetId === '__new' ? _vm.$t('Common.create') : _vm.$t('Common.save'),
      "title": _vm.isCreating ? _vm.$t('Dashboards.components.widgetEditDialog.title.create') : _vm.$t('Dashboards.components.widgetEditDialog.title.edit')
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "action:save": _vm.save
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_vm.widget ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTabs, {
    attrs: {
      "show-arrows": "",
      "grow": "",
      "data-cy": "widget-editor-tabs"
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#general",
      "data-cy": "tab-general"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.general.title')) + "\n          ")]), _vm.editedWidget.type !== 'empty' ? _c(VTab, {
    attrs: {
      "href": "#twins",
      "data-cy": "tab-twins"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.twins.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type !== 'empty' ? _c(VTab, {
    attrs: {
      "href": "#virtual-devices",
      "data-cy": "tab-virtual-devices"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.virtualDevices.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'chart' ? _c(VTab, {
    attrs: {
      "href": "#chart-data",
      "data-cy": "tab-chart-data"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.chartData.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'chart' ? _c(VTab, {
    attrs: {
      "href": "#chart",
      "data-cy": "tab-chart"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.chart.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'chart' && _vm.get(_vm.editedWidget, 'chartOptions.type') === 'custom' ? _c(VTab, {
    attrs: {
      "data-cy": "tab-chart-custom-code",
      "href": "#chart-custom-code"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.chartCustomCode.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'twin-table' ? _c(VTab, {
    attrs: {
      "href": "#twin-table",
      "data-cy": "tab-table"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.twinTable.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'twin-map' ? _c(VTab, {
    attrs: {
      "href": "#twin-map",
      "data-cy": "tab-map"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.twinMap.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'twin-map' ? _c(VTab, {
    attrs: {
      "href": "#twin-map-marker",
      "data-cy": "tab-map-marker"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.twinMapMarker.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'twin-map' && _vm.get(_vm.editedWidget, 'twinMapOptions.hasPopup') ? _c(VTab, {
    attrs: {
      "href": "#twin-map-popup-attributes",
      "data-cy": "tab-map-popup-attributes"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.twinMapPopupAttributes.title')) + "\n          ")]) : _vm._e(), _vm.editedWidget.type === 'twin-map' && _vm.get(_vm.editedWidget, 'twinMapOptions.hasPopup') ? _c(VTab, {
    attrs: {
      "data-cy": "tab-map-popup-actions",
      "href": "#twin-map-popup-actions"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.tabs.twinMapPopupActions.title')) + "\n          ")]) : _vm._e()], 1), _c(VTabsItems, {
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    attrs: {
      "value": "general"
    }
  }, [_c('widget-meta-editor', {
    attrs: {
      "data-set": _vm.dataSet,
      "custom-parameters": _vm.customParameters
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "twins",
      "eager": ""
    }
  }, [_c('twin-filter-editor', {
    attrs: {
      "value": _vm.twinFilter,
      "custom-parameters": _vm.customParameters,
      "dashboard-id": _vm.dashboardId
    },
    on: {
      "input": _vm.setTwinFilter
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "virtual-devices",
      "eager": ""
    }
  }, [_c('virtual-device-filter-editor', {
    attrs: {
      "value": _vm.virtualDeviceFilter,
      "custom-parameters": _vm.customParameters,
      "dashboard-id": _vm.dashboardId
    },
    on: {
      "input": _vm.setVirtualDeviceFilter
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "chart-data",
      "eager": _vm.editedWidget.type === 'chart'
    }
  }, [_c('widget-chart-data-options-editor', {
    attrs: {
      "custom-parameters": _vm.customParameters,
      "dashboard-id": _vm.dashboardId
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "chart"
    }
  }, [_c('widget-chart-options-editor', {
    attrs: {
      "custom-parameters": _vm.customParameters,
      "dashboard-id": _vm.dashboardId
    },
    on: {
      "open-code-editor": function ($event) {
        _vm.tabItem = 'chart-custom-code';
      }
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "chart-custom-code"
    }
  }, [_c('chart-custom-options-editor-code-editor', {
    attrs: {
      "show-options-preview": _vm.showOptionsPreview
    },
    on: {
      "update:showOptionsPreview": function ($event) {
        _vm.showOptionsPreview = $event;
      }
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "twin-table",
      "eager": _vm.editedWidget.type === 'twin-table'
    }
  }, [_c('widget-twin-table-options-editor', {
    attrs: {
      "custom-parameters": _vm.customParameters,
      "dashboard-id": _vm.dashboardId,
      "data": _vm.dataSet.data
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "twin-map",
      "eager": _vm.editedWidget.type === 'twin-map'
    }
  }, [_c('widget-twin-map-options-editor', {
    attrs: {
      "dashboard-id": _vm.dashboardId
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "twin-map-marker",
      "eager": _vm.editedWidget.type === 'twin-map'
    }
  }, [_c('twin-map-marker-options-editor', {
    attrs: {
      "data": _vm.dataSet.data,
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "twin-map-popup-attributes",
      "eager": _vm.editedWidget.type === 'twin-map'
    }
  }, [_c('twin-map-popup-editor', {
    attrs: {
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters,
      "data": _vm.dataSet.data
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  })], 1), _c(VTabItem, {
    attrs: {
      "value": "twin-map-popup-actions",
      "eager": _vm.editedWidget.type === 'twin-map'
    }
  }, [_vm.dataSet.data ? _c('twin-map-actions-editor', {
    attrs: {
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters,
      "data": _vm.dataSet.data
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  }) : _vm._e()], 1)], 1)], 1), _c(VCol, {
    staticClass: "grayBox",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, {
    staticStyle: {
      "position": "sticky",
      "top": "0"
    }
  }, [_c(VCol, [_c('widget-card', {
    attrs: {
      "widget": _vm.editedWidget,
      "data-set": _vm.dataSet,
      "date-range": _vm.dateRange,
      "data-set-is-loading": _vm.isFetchingDataSet,
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters,
      "is-preview": "",
      "display-as-json": _vm.get(_vm.editedWidget, 'chartOptions.type') === 'custom' && _vm.showOptionsPreview
    },
    on: {
      "refresh-data": _vm.fetchDataSet
    }
  })], 1)], 1)], 1)], 1) : _c(VAlert, {
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Dashboards.components.widgetEditDialog.alert.noWidget')) + "\n    ")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };